import springApi from '../../services/springApi'

export const getModelRankings = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/model_rankings', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeModelRanking = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/model_rankings', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteModelRanking = id => (
	new Promise((resolve, reject) => {
		springApi()
			.delete(`/model_rankings/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

